import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";
import type { WorkHours } from '../types';

export const setWebsiteClaim = httpsCallable(functions, 'setWebsiteClaim');
export const disableEmployeeLoginCallable = httpsCallable(functions, 'disableEmployeeLogin');
const createEmployeeInvitationCallable = httpsCallable<
  { tenantId: string; isAdmin: boolean; serviceIds: string[] },
  { accessCode: string; tenantId: string; expiresAt: string }
>(functions, 'createEmployeeInvitation');

// This handles setting the token on the auth user with the website id so we know to relate them to that website.
export const callSetWebsiteClaim = async (
  userId: string,
  accessCode: string,
  setup?: { profile: { firstName: string; lastName: string; phone: string }; workHours: WorkHours }
) => {
    return setWebsiteClaim({ userId, accessCode, ...setup });
};

export const callDisableEmployeeLogin = async (siteId: string, employeeId: string) => {
    try {
        return await disableEmployeeLoginCallable({ siteId, employeeId });
    } catch (error) {
        console.error('Error calling disableEmployeeLogin:', error);
        throw error;
    }
};

export const callCreateEmployeeInvitation = async (
  tenantId: string,
  isAdmin: boolean,
  serviceIds: string[]
) => {
  const result = await createEmployeeInvitationCallable({tenantId, isAdmin, serviceIds});
  return result.data;
};
